/*
 * @Author: your name
 * @Date: 2021-12-13 21:56:11
 * @LastEditTime: 2021-12-13 22:46:09
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /xueersi.com-transition/mall-www-source/src/networks/init.js
 */
import axios from 'axios'
import http from 'http'
import https from 'https'
import { baseURL } from '@/config'
import { parseCookie } from '@/util/parseCookie'

const httpAgent = new http.Agent({ keepAlive: true })
const httpsAgent = new https.Agent({ keepAlive: true })

if (process.env.NODE_ENV !== 'local') {
  axios.defaults.baseURL = baseURL
}
axios.defaults.baseURL = baseURL
axios.defaults.maxRedirects = 0
axios.defaults.withCredentials = true

/**
 * 获取用户的年级
 */
function getUserGrade(config) {
  // 优先级：grade_id = currentGrade(用户选择的年级) > rootState.cookies.userGrade（用户账号的年级） > 4（默认是4）
  let grade_id
  // 如果传入了rootState
  if (config.rootState && config.rootState.cookies) {
    const cookies = config.rootState.cookies
    // // userInfo.grade_id 如果userInfo存在
    // if(rootState.userIsLogin && rootState.user && rootState.user.userInfo){
    //   grade_id = config.rootState.user.userInfo.grade_id
    // } else

    if (cookies.currentGrade) {
      grade_id = cookies.currentGrade
    } else if (cookies.userGrade) {
      grade_id = cookies.userGrade
    }
  }
  return Number(grade_id) || 4
}

axios.interceptors.response.use(
  response => {
    // console.log('=====response====', response)
    return response
  },
  e => {
    return Promise.reject(e)
  }
)

axios.interceptors.request.use(
  config => {
    // console.log('======config=============', config)
    // Do something before request is sent
    // console.log('===config key exists====', 'X-Region' in config.headers.common, config.url || 'who am i')
    config.httpAgent = httpAgent
    config.httpsAgent = httpsAgent
    if (!('X-Region' in config.headers.common) && 'rootState' in config) {
      config.headers.common['X-Region'] = config.rootState.xAreaID || 100
    }
    if (
      !('TraceId' in config.headers.common) &&
      'rootState' in config &&
      process.env.VUE_ENV === 'server'
    ) {
      config.headers.common['TraceId'] = config.rootState.traceid || ''
    }
    const route = config.rootState ? config.rootState.route : ''
    const domain = config.url.split('/')[2]
    if (route && domain === 'mall.xueersi.com') {
      config.params = {
        switch_grade: route.query.switch_grade || -1,
        switch_subject: route.query.switch_subject || -1,
        ...config.params
      }
    }
    // 用户相关接口合并
    if (
      !('cookie' in config.headers.common) &&
      'rootState' in config &&
      process.env.VUE_ENV === 'server'
    ) {
      config.headers.common['cookie'] = parseCookie(config.rootState.cookies)
    }
    // 如果没有拼接x-grade字段并且是mall域，那么进行拼接
    if (!config.headers['x-grade'] && domain === 'mall.xueersi.com') {
      config.headers['x-grade'] = getUserGrade(config)
    }
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)



// WEBPACK FOOTER //
// ./src/networks/init.js